"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
var _gray_route_config = require("@/api/cfg/gray_route_config");
var _shopList = require("@/api/shop/shopList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GrayRouteConfig',
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      list: [],
      total: 0,
      cityList: [],
      queryParams: {
        page: 1,
        limit: 10,
        regionId: null,
        enabled: null
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        regionId: null,
        enabled: 1,
        remark: ''
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑灰度白名单' : '新增灰度白名单';
    },
    rules: function rules() {
      return {
        regionId: [{
          required: true,
          message: '请选择城市',
          trigger: 'change'
        }]
      };
    }
  },
  created: function created() {
    this.loadCityList();
    this.getList();
  },
  methods: {
    loadCityList: function loadCityList() {
      var _this = this;
      (0, _shopList.getEffectiveCityList)({
        regionType: 2
      }).then(function (response) {
        _this.cityList = response.data || [];
      });
    },
    getRegionName: function getRegionName(regionId) {
      var city = this.cityList.find(function (c) {
        return c.regionId === regionId;
      });
      return city ? city.regionName : '#' + regionId;
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      (0, _gray_route_config.getConfigPage)(this.queryParams).then(function (response) {
        _this2.list = response.data.list || [];
        _this2.total = response.data.total || 0;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.queryParams.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.queryParams.page = current;
      this.getList();
    },
    handleRefreshCache: function handleRefreshCache() {
      var _this3 = this;
      (0, _gray_route_config.refreshCache)().then(function () {
        _this3.$message.success('缓存刷新成功');
      });
    },
    handleAdd: function handleAdd() {
      var _this4 = this;
      this.isEdit = false;
      this.form = {
        id: null,
        regionId: null,
        enabled: 1,
        remark: ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs.form && _this4.$refs.form.clearValidate();
      });
    },
    handleEdit: function handleEdit(row) {
      var _this5 = this;
      this.isEdit = true;
      this.form = {
        id: row.id,
        regionId: row.regionId,
        enabled: row.enabled,
        remark: row.remark || ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs.form && _this5.$refs.form.clearValidate();
      });
    },
    submitForm: function submitForm() {
      var _this6 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this6.submitLoading = true;
        var apiFn = _this6.isEdit ? _gray_route_config.updateConfig : _gray_route_config.saveConfig;
        apiFn(_this6.form).then(function () {
          _this6.$message.success(_this6.isEdit ? '修改成功' : '新增成功');
          _this6.dialogVisible = false;
          _this6.submitLoading = false;
          _this6.getList();
        }).catch(function () {
          _this6.submitLoading = false;
        });
      });
    },
    formatDateTime: function formatDateTime(row, column, cellValue) {
      if (!cellValue) return '';
      var d = new Date(cellValue);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var h = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      var s = String(d.getSeconds()).padStart(2, '0');
      return y + '-' + m + '-' + day + ' ' + h + ':' + min + ':' + s;
    },
    handleDelete: function handleDelete(row) {
      var _this7 = this;
      this.$confirm('确认删除该城市的灰度白名单配置？', '删除确认', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _gray_route_config.deleteConfig)(row.id).then(function () {
          _this7.$message.success('删除成功');
          _this7.getList();
        });
      }).catch(function () {});
    }
  }
};